import type { ReactNode } from "react";

/**
 * Where a field's hint goes.
 *
 * `tip` — the default — folds it behind an info icon beside the label, which is
 * what took several screens of explanatory prose out of the scenario editor.
 * `below` keeps it as prose under the control, for the rare sentence that is the
 * point rather than a footnote to it.
 *
 * Here rather than in `Field.tsx` so both field shells can import it without
 * either of them exporting a non-component and breaking fast refresh.
 */
export type HintPlacement = "tip" | "below";

/** The tip trigger needs a string; a `ReactNode` label falls back to something. */
export function labelText(label: ReactNode): string {
  return typeof label === "string" ? label : "this field";
}
